import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiKeyService, CreateApiKeyRequest } from '../../services/api/apiKeyService';

export const fetchApiKeys = createAsyncThunk(
  'apiKey/fetchApiKeys',
  async ({ page, pageSize }: { page: number; pageSize: number }, { rejectWithValue }) => {
    try {
      return await apiKeyService.getApiKeys(page, pageSize);
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to fetch API keys');
    }
  }
);

export const createApiKey = createAsyncThunk(
  'apiKey/createApiKey',
  async (request: CreateApiKeyRequest, { rejectWithValue }) => {
    try {
      return await apiKeyService.createApiKey(request);
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to create API key');
    }
  }
);

export const revokeApiKey = createAsyncThunk(
  'apiKey/revokeApiKey',
  async (id: number, { rejectWithValue }) => {
    try {
      await apiKeyService.revokeApiKey(id);
      return id;
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to revoke API key');
    }
  }
);

export const fetchApiKeyUsage = createAsyncThunk(
  'apiKey/fetchApiKeyUsage',
  async ({ id, fromDate, toDate }: { id: number; fromDate?: string; toDate?: string }, { rejectWithValue }) => {
    try {
      return await apiKeyService.getApiKeyUsage(id, fromDate, toDate);
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to fetch API key usage');
    }
  }
);

export const rotateApiKey = createAsyncThunk(
  'apiKey/rotateApiKey',
  async (id: number, { rejectWithValue }) => {
    try {
      return await apiKeyService.rotateApiKey(id);
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to rotate API key');
    }
  }
);
